import type {
  ChatChannel,
  ConversationDetail,
  ConversationListItem,
  ConversationStatusWritable,
  ConversationUpdateInput,
} from "@chat-yai/shared/admin-types";
import type { PaginatedResponse } from "@chat-yai/shared";
import { request } from "@/api/client";

export const conversationsApi = {
  list(
    query: {
      chatbot_id?: string;
      channel?: ChatChannel;
      status?: ConversationStatusWritable;
      assignee_user_id?: string | null;
      unread_only?: boolean;
      include_archived?: boolean;
      q?: string;
      from?: string;
      to?: string;
      page?: number;
      page_size?: number;
    } = {},
  ) {
    return request<PaginatedResponse<ConversationListItem>>(
      "/admin/conversations",
      { query },
    );
  },
  get(id: string) {
    return request<ConversationDetail>(`/admin/conversations/${id}`);
  },
  update(id: string, input: ConversationUpdateInput) {
    return request<{ conversation: ConversationListItem }>(
      `/admin/conversations/${id}`,
      { method: "PATCH", body: input },
    );
  },
  summarize(id: string) {
    return request<{ summary_status: string }>(
      `/admin/conversations/${id}/summarize`,
      { method: "POST", body: {} },
    );
  },
};
